import type { TArticle } from '~/types/common';
import { shuffleArray } from '~/utils/arrays';

export const preparePosts = (posts: TArticle[], area: string): TArticle[] => {
  if (!posts) {
    return [];
  }
  const result = [...posts];

  const randomNumsFirst = shuffleArray([0, 4]);
  const randomNumsSecond = shuffleArray([1, 5]);
  const randomNumsThird = shuffleArray([2, 6]);
  const randomNumsFourth = shuffleArray([3, 7]);

  if (area === 'sidebar') {
    return shuffleArray(result).slice(0, 1);
  }

  switch (posts.length) {
    case 4:
      return posts.slice(0, 4);
    case 5:
      result[0] = posts[randomNumsFirst[0]];
      return result.slice(0, 4);
    case 6:
      result[0] = posts[randomNumsFirst[0]];
      result[1] = posts[randomNumsSecond[0]];
      return result.slice(0, 4);
    case 7:
      result[0] = posts[randomNumsFirst[0]];
      result[1] = posts[randomNumsSecond[0]];
      result[2] = posts[randomNumsThird[0]];
      return result.slice(0, 4);
    case 8:
      result[0] = posts[randomNumsFirst[0]];
      result[1] = posts[randomNumsSecond[0]];
      result[2] = posts[randomNumsThird[0]];
      result[3] = posts[randomNumsFourth[0]];
      return result.slice(0, 4);
  }
  return shuffleArray(result).slice(0, 4);
};
